import { useState } from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { hotDiscussions } from '@/mocks/community';

export default function HomeVoices() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const list = hotDiscussions.slice(0, 4);

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
      <Reveal>
        <SectionHeading
          eyebrow="Voices"
          title="讨论区最近在吵什么"
          desc="这里没有标准答案，只有不同的推理过程。点开任意一条，可以看到完整的评论区。"
          action={
            <Link
              to="/community"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
            >
              去讨论区
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          }
        />
      </Reveal>

      <div className="mt-7 grid grid-cols-1 gap-5 md:grid-cols-2">
        {list.map((item, index) => (
          <Reveal key={item.id} delay={index * 70}>
            <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold text-background-50 ${item.avatarBg}`}
                  aria-hidden="true"
                >
                  {item.user.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-semibold text-foreground-900">{item.user}</span>
                  <span className="text-[11px] text-foreground-400">{item.time}</span>
                </span>
                <span className="ml-auto rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-800">
                  {item.replies} 回复
                </span>
              </div>

              <p className="mt-4 flex-1 text-[13px] leading-relaxed text-foreground-700 md:text-sm">
                {item.content}
              </p>

              <Link
                to={`/topic/${item.topicId}`}
                className="mt-4 flex items-center gap-1.5 rounded-md bg-background-100 px-3 py-2 text-xs text-foreground-600 transition-colors hover:bg-accent-100 hover:text-accent-900"
              >
                <i className="ri-link" aria-hidden="true" />
                正在讨论：{item.topicTitle}
              </Link>

              <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                <button
                  type="button"
                  onClick={() => toggleLike(item.id)}
                  aria-pressed={Boolean(liked[item.id])}
                  className={`flex cursor-pointer items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium transition-colors ${
                    liked[item.id]
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-500 hover:bg-background-100'
                  }`}
                >
                  <i
                    className={liked[item.id] ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'}
                    aria-hidden="true"
                  />
                  {item.likes + (liked[item.id] ? 1 : 0)}
                </button>
                <Link
                  to={`/topic/${item.topicId}`}
                  className="flex items-center gap-1 text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  参与讨论
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </Link>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}